import { AppProps } from '@/store/iam';
// 在.env里面改子应用的地址
const entryMap = {
  'xag-ai-dataset': import.meta.env.VITE_APP_dataset,
  'xag-ai-dimension': import.meta.env.VITE_APP_dimension,
  'xag-ai-application': import.meta.env.VITE_APP_application,
  'xag-ai-inference': import.meta.env.VITE_APP_inference,
  'xag-ai-algorithm': import.meta.env.VITE_APP_algorithm,
  'xag-ai-common': import.meta.env.VITE_APP_common,
};
console.log(entryMap);

const icons = {
  'xag-ai-dataset': 'icon-xag-ai-dataset',
  'xag-ai-dimension': 'icon-xag-ai-dimension',
  'xag-ai-application': 'icon-xag-ai-appcenter',
  'xag-ai-inference': 'icon-xag-ai-inference',
  'xag-ai-algorithm': 'icon-xag-ai-algorithm',
  'xag-ai-cloud': 'icon-xag-ai-cloud',
  'xag-ai-report': 'icon-report',
  'xag-ai-business': 'icon-business',

  'xag-ai-online-app': 'icon-yun_o',
  'xag-ai-edge-app': 'icon-cpu',
  admin: 'icon-admin',
  home: 'icon-home-page',
};

/**
 * 本应用对应权限字段
 */
export const AppPermissions = {
  // 数据中心
  mydataset: ['view:xag-ai-dataset.mydataset'],
  datapool: ['view:xag-ai-dataset.datapool'],
  // 标注中心
  labelingRequirement: ['view:xag-ai-dimension.labeling-requirement'],
  annotationTask: ['view:xag-ai-dimension.annotation-task'],
  teamLabelingRequirement: ['view:xag-ai-dimension.team-labeling-requirement'],
  team: ['view:xag-ai-dimension.team'],

  // 应用
  application: ['view:xag-ai-application.application'],
  algorithm: ['view:xag-ai-application.algorithm'],
  // 推理
  myinference: ['view:xag-ai-inference.myinference'],
  assistantinference: ['view:xag-ai-inference.assistantinference'],
};

export function createApp(props: any) {
  return Object.keys(entryMap).map((i) => {
    return {
      name: i,
      entry: entryMap[i],
      container: '#home',
      activeRule: `#/portal/${i}`,
      props,
    };
  });
}
// type: 0菜单,1页面，2是按钮
export function createMenu(app: AppProps[]) {
  const result: Array<{
    label: string;
    value: string;
    icon: string;
    url?: string;
    chidren: any[];
  }> = [];
  let temp;
  app.sort((a, b) => b.sort - a.sort);
  app.forEach((i) => {
    if (i.type != 0) {
      return;
    }

    temp = {
      label: i.name,
      value: i.key,
      icon: icons[i.key],
      url: i.url,
    };

    if (i.childList) {
      temp.chidren = createMenu(i.childList);
    }
    result.push(temp);
  });
  return result;
}
